import resetMixin from "@/helper/resetForm";
import axios from "axios";
import tokenClear from "@/helper/eraseToken";

export const npbu_wakil = {
    mixins: [resetMixin, tokenClear],
    methods: {
        // handle file input
        handleFile(event) {
            const file = event.target.files[0];
            this.form.dok_sk = file;
        },
        // store data jabatan
        async store() {
            try {
                this.isLoading = true;
                this.form.nama = this.form.nama.toUpperCase();
                this.form.npbu_id = this.helper.npbu_id;
                this.form.status_sk = this.helper.status_sk;
                // buat form data object
                const formData = new FormData();
                formData.append("dok_sk", this.form.dok_sk);
                formData.append("nik", this.form.nik);
                formData.append("npbu_id", this.form.npbu_id);
                formData.append("nama", this.form.nama);
                formData.append("nomp", this.form.nomp);
                formData.append("notelepon", this.form.notelepon);
                formData.append("email", this.form.email);
                formData.append("alamat", this.form.alamat);
                formData.append(
                    "wilayah_kelurahan_id",
                    this.form.wilayah_kelurahan_id
                );
                formData.append("kodepos", this.form.kodepos);
                formData.append("jabatan", this.form.jabatan);
                formData.append("no_sk", this.form.no_sk);
                formData.append("tgl_sk", this.form.tgl_sk);
                formData.append("status_sk", this.form.status_sk);
                // store data npbu wakil
                let response = await axios.post(
                    "/api/bumd/npbu-wakil",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );
                if (response.data.data) {
                    this.isLoading = false;
                    this.editMode = true
                    this.$swal({
                        icon: "success",
                        title: "Data berhasil ditambah",
                        // text:
                        //     "Silahkan tekan tombol selanjutnya untuk menambahkan data Penanggung Jawab.",
                        type: "success",
                        confirmButtonClass: "btn btn-info",
                        showConfirmButton: true,
                        confirmButtonText: "OKE",
                        showCloseButton: true,
                        timer: 5000
                    });
                    this.helper.buttonDisabled = false;
                    this.helper.errors = []
                    this.getDetailNpbu(this.helper.npbu_id)
                    // this.reset()
                }
            } catch (error) {
                this.isLoading = false;
                if (this.$route.name == "Pimpinan") {
                    this.editMode = false;
                } else {
                    this.modeEdit = false;
                }
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data;
                } else {
                    console.log(error);
                }
            }
        },
        // update data wakil
        async update(npbu_wakil_id) {
            try {
                this.isLoading = true;
                this.form.nama = this.form.nama.toUpperCase();
                this.form.npbu_id = this.helper.npbu_id;
                this.form.dok_sk = "";
                this.form.notelepon =
                    this.form.notelepon == null ? "" : this.form.notelepon;
                this.form.tgl_sk =
                    this.form.tgl_sk == null ? "" : this.form.tgl_sk;
                // buat form data object
                const formData = new FormData();
                formData.append("dok_sk", this.form.dok_sk);
                formData.append("aktif", this.form.aktif);
                formData.append("nik", this.form.nik);
                formData.append("npbu_id", this.form.npbu_id);
                formData.append("nama", this.form.nama);
                formData.append("nomp", this.form.nomp);
                formData.append("notelepon", this.form.notelepon);
                formData.append("email", this.form.email);
                formData.append("alamat", this.form.alamat);
                formData.append(
                    "wilayah_kelurahan_id",
                    this.form.wilayah_kelurahan_id
                );
                formData.append("kodepos", this.form.kodepos);
                formData.append("jabatan", this.form.jabatan);
                formData.append("no_sk", this.form.no_sk);
                formData.append("tgl_sk", this.form.tgl_sk);
                formData.append("status_sk", this.form.status_sk);
                formData.append("_method", "PUT");
                // store data npbu wakil
                let response = await axios.post(
                    "/api/bumd/npbu-wakil/" + npbu_wakil_id,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );
                if (response.data.data) {
                    this.isLoading = false;
                    this.editMode = true;
                    this.$swal({
                        icon: "success",
                        title: "Data berhasil dirubah",
                        text: "Silahkan periksa kembali data anda.",
                        type: "success",
                        confirmButtonClass: "btn btn-info",
                        showConfirmButton: true,
                        confirmButtonText: "OKE",
                        showCloseButton: true,
                        timer: 5000
                    });
                }
            } catch (error) {
                this.isLoading = false;
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data;
                } else {
                    console.log(error);
                }
            }
        },
        // detail data npbu
        async getDetailNpbu(npbu_id) {
            try {
                let response = await axios.get("/api/bumd/npbu/" + npbu_id);
                const items = response.data.data;
                this.helper.no_pokok = items.no_pokok;
                switch (this.$route.name) {
                    case 'Pimpinan': 
                    case 'StepNpbu2':
                    case 'EditNpbu2':
                        if (items.pimpinan) {
                            // console.log(items.pimpinan);
                            this.editMode = true;
                            this.helper.pimpinan_id = items.pimpinan.id;
                            this.getDetailWakil(items.pimpinan.id);
                            this.helper.buttonDisabled = false;
                        }
                        break
                    case 'PenanggungJawab':
                    case 'StepNpbu3':
                    case 'EditNpbu3':
                        if (items.penanggung_jawab) {
                            this.modeEdit = true;
                            this.helper.penanggung_jawab = items.penanggung_jawab.id;
                            this.getDetailWakil(items.penanggung_jawab.id);
                            // dipanggil di komponen penanggung jawab
                            this.helper.detailNpbu = items;
                            this.helper.buttonDisabled = false
                        }
                        break
                    default:
                        return null
                }
                if (items.status_registrasi) {
                    // vuex - set status registrasi
                    this.$store.commit(
                        "Npbu/inputStatus",
                        items.status_registrasi
                    );
                }
            } catch (error) {
                if (error.response.status == 401) {
                    // hapus token mixins
                    this.clearAll();
                }
            }
        },
        // detail npbu wakil
        async getDetailWakil(wakil_id) {
            try {
                let response = await axios.get(
                    "/api/bumd/npbu-wakil/" + wakil_id
                );
                const items = response.data.data;
                this.form.fill(items);
                if (items.wilayah_kelurahan) {
                    this.wilayah = {
                        provinsi:
                            items.wilayah_kelurahan.wilayah_kecamatan
                                .wilayah_kabkota.wilayah_provinsi_id,
                        kabkota:
                            items.wilayah_kelurahan.wilayah_kecamatan
                                .wilayah_kabkota_id,
                        kecamatan: items.wilayah_kelurahan.wilayah_kecamatan_id
                    };
                    // vuex - call semua wilayah
                    this.$store.dispatch(
                        "Wilayah/getKabkota",
                        this.wilayah.provinsi
                    );
                    this.$store.dispatch(
                        "Wilayah/getKecamatan",
                        this.wilayah.kabkota
                    );
                    this.$store.dispatch(
                        "Wilayah/getKelurahan",
                        this.wilayah.kecamatan
                    );
                }
            } catch (error) {
                if (error.response.status == 401) {
                    // hapus token mixins
                    this.clearAll();
                }
            }
        },
        // kirim permohonan
        async kirimPermohonanApi(npbu_id) {
            try {
                this.helper.showLoader = true;
                console.log(this.helper.no_pokok)
                let response = await axios.put(
                    "/api/bumd/npbu/kirim-permohonan/" + npbu_id
                );
                if (response.data.data) {
                    const items = response.data.data;
                    // vuex - set status registrasi
                    this.helper.showLoader = false;
                    if (items.status_registrasi) {
                        this.$store.commit(
                            "Npbu/inputStatus",
                            items.status_registrasi
                        );
                    }
                    this.$swal({
                        icon: "success",
                        title: "Permohonan anda berhasil dikirim.",
                        showConfirmButton: true,
                        showCloseButton: true,
                        confirmButtonText: "OKE",
                        confirmButtonClass: "btn btn-primary",
                        timer: 5000
                    });
                    this.$router.push({ name: 'Profil' })
                    // set data telah selesai ke localstorage
                    // localStorage.setItem("selesai", true);
                    // this.getDetailNpbu(npbu_id)
                    // vuex - set selesai untuk step
                    // this.$store.commit("inputSelesai", true);
                }
            } catch (error) {
                this.helper.showLoader = false;
                localStorage.setItem("selesai", false)
                if (error.response.status == 401) {
                    // mixins - hapus token
                    this.clearAll();
                } else if (error.response.status == 404) {
                    this.$swal({
                        icon: "error",
                        title: "Terjadi Masalah.",
                        text:
                            "Error: " +
                            error.response.status +
                            ", Data tidak ditemukan.",
                        showConfirmButton: true,
                        showCloseButton: true,
                        confirmButtonText: "OKE",
                        confirmButtonClass: "btn btn-primary"
                    });
                } else {
                    this.$swal({
                        icon: "error",
                        title: "Terjadi Masalah.",
                        text: error.response.data.status.message,
                        showConfirmButton: true,
                        showCloseButton: true,
                        confirmButtonText: "OKE",
                        confirmButtonClass: "btn btn-primary"
                    });
                }
            }
        }
    }
};

export default npbu_wakil;
